var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCorrect(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3_796)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28.0014 0.500782V0.500833L28.0086 0.500775C40.8918 0.394889 51.812 11.1628 51.4932 24.6003C51.1955 37.1269 40.7199 47.8169 27.3624 47.4928L27.3623 47.4928C14.8512 47.1918 4.1622 36.7051 4.50818 23.3289L4.50818 23.3288C4.8311 10.8042 15.1984 0.423194 28.0014 0.500782ZM4.00836 23.3159H4.00835H4.00836ZM27.309 33.6642L27.3092 33.6639C31.909 29.0778 36.5077 24.4897 41.0829 19.8768L40.7279 19.5247L41.0829 19.8768C42.1898 18.7608 42.4909 17.3358 41.9756 15.8474L41.9756 15.8473C40.9969 13.0219 37.5287 12.3261 35.4034 14.4464C31.8283 18.0126 28.2531 21.581 24.7002 25.1722L24.7002 25.1722C24.6443 25.2287 24.6025 25.2652 24.5724 25.2884C24.5395 25.2617 24.4946 25.2205 24.4334 25.1571C23.1534 23.8291 21.8431 22.5323 20.5337 21.2425C18.9438 19.6762 16.4621 19.6629 14.9237 21.2242L14.9237 21.2242C13.4006 22.7703 13.411 25.2227 14.9652 26.7936L14.9652 26.7936C17.2259 29.078 19.5025 31.346 21.7788 33.6117C22.5508 34.3804 23.5087 34.7479 24.5633 34.7791L25.0781 34.7944V34.7377C25.9128 34.6255 26.6799 34.2904 27.309 33.6642Z",
    fill: "#8BFFBF",
    stroke: "#1C9552"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.5781 34.2794C23.638 34.2515 22.805 33.928 22.1315 33.2574C19.8551 30.9917 17.5798 28.7249 15.3206 26.442C13.9554 25.0622 13.9533 22.9229 15.2799 21.5752C16.6173 20.2179 18.7823 20.219 20.1828 21.5988C21.4923 22.8886 22.7986 24.1827 24.0738 25.5046C24.4454 25.8903 24.6467 25.9374 25.0557 25.5239C28.6073 21.9341 32.1814 18.3667 35.7565 14.8005C37.6378 12.9247 40.653 13.5578 41.5031 16.011C41.9582 17.3255 41.6959 18.5489 40.7279 19.5248C36.1538 24.1366 31.5561 28.7238 26.9562 33.3099C26.3127 33.9505 25.4968 34.2462 24.5781 34.2783V34.2794Z",
    fill: "#FDFEFD"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3_796",
    x: 0,
    y: 0,
    width: 56,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3_796"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3_796",
    result: "shape"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCorrect);
export default __webpack_public_path__ + "static/media/Correct.024b1cccbd80577df435656c2184983e.svg";
export { ForwardRef as ReactComponent };